import { ref, computed, onMounted, onBeforeUnmount } from "vue";

export function usePageScale(baseWidth = 1920, baseHeight = 1080, mode = "width") {
  const scale = ref(1);

  const updateScale = () => {
    const clientWidth = document.documentElement.clientWidth;
    const clientHeight = document.documentElement.clientHeight;

    let scaleX = clientWidth/ baseWidth;
    let scaleY = clientHeight / baseHeight;

    if (mode === "width") {
      scale.value = scaleX;
    } else if (mode === "height") {
      scale.value = scaleY;
    } else if (mode === "auto") {
      scale.value = Math.min(scaleX, scaleY);
    }
  };

  onMounted(() => {
    updateScale();
    window.addEventListener("resize", updateScale);
  });

  onBeforeUnmount(() => {
    window.removeEventListener("resize", updateScale);
  });

  const scaleStyle = computed(() => {
    // const width = baseWidth * scale.value;
    // const height = baseHeight * scale.value;

    return {
      transform: `scale(${scale.value})`,
      transformOrigin: "top left",
      width: baseWidth + "px",     // ⚠️ 保持缩放前的宽度
      height: baseHeight + "px",  // ⚠️ 保持缩放前的高度
      position: "absolute",       // 让缩放后的尺寸不影响外层流式布局
      left: 0,
      top: 0,
    };
  });

  // 外层容器需要撑开真实大小（防止出现空白）
  const wrapperStyle = computed(() => ({
    width: baseWidth * scale.value + "px",
    height: baseHeight * scale.value + "px",
    overflow: "auto",
    position: "relative",
  }));

  return { scaleStyle, wrapperStyle };
}
